import {useMemo} from 'react';
import {
  ChartData,
} from 'chart.js';
import { originalColors } from '../constants/originalColors';
import { MonthlyCostData } from '../constants/types';


export const useMonthlyCostChartData=(fullLabels: string[], fullDataPoints: number[]): ChartData<'bar'> =>
useMemo(() => {
  const labels = fullLabels.slice(-3);
  const dataPoints = fullDataPoints.slice(-3);
    return {
        labels,
        datasets: [
          {
            label: 'Cost ($)',
            data: dataPoints,
            backgroundColor: originalColors.slice(0, dataPoints.length),
            borderColor: 'rgb(255, 99, 132)',
            maxBarThickness: 10,
          },
        ],
      }
  }, [fullLabels, fullDataPoints]);


   export const useExpandedMonthlyCostChartData = (hasConfirmed: boolean, graphData: MonthlyCostData[], initialData: MonthlyCostData[]): ChartData<'bar'> =>
    useMemo(() => {
      const sourceData = hasConfirmed && graphData ? graphData : initialData;
  
      const filteredLabels = sourceData!.map(item => item.month); // ['01', '02', ...]
      const filteredDataPoints = sourceData!.map(item => item.cost || 0);
    
      return {
        labels: filteredLabels,
        datasets: [
          {
            label: 'Cost ($)',
            data: filteredDataPoints,
            backgroundColor: originalColors.slice(0, filteredDataPoints.length),
            borderColor: 'rgb(255, 99, 132)',
            maxBarThickness: 10,
          },
        ],
      };
    }, [hasConfirmed, graphData, initialData]);